import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../../api/api";
import { AuthContext } from "../../../context/AuthContext";
import { FaUser, FaEnvelope, FaLock, FaArrowLeft, FaUserPlus, FaEye, FaEyeSlash } from "react-icons/fa";
import "../Login/Login.css";

const PASSWORD_RULE =
  "Minimum 8 chars with uppercase, lowercase, number, and special character.";

const Register = () => {
  const navigate = useNavigate();
  const { user, loading: authLoading } = useContext(AuthContext);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!authLoading && user) navigate("/", { replace: true });
  }, [user, authLoading, navigate]);

  const handle = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);
    try {
      const res = await API.post("/auth/register", { name, email, password });
      setMessage(res.data?.message || "Registration successful. Please login.");
      setTimeout(
        () =>
          navigate("/login", {
            replace: true,
          }),
        900
      );
    } catch (err) {
      setError(err?.message || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <FaUserPlus className="auth-icon" />
          <h2>Create Account</h2>
          <p>Register with a strong password and verify your email.</p>
        </div>

        {error && <div className="auth-error">{error}</div>}
        {message && <div className="auth-success">{message}</div>}

        <form className="auth-form" onSubmit={handle}>
          <div className="input-group">
            <FaUser className="input-icon" />
            <input
              placeholder="Full Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <FaEnvelope className="input-icon" />
            <input
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="input-group has-action">
            <FaLock className="input-icon" />
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="input-action"
              onClick={() => setShowPassword((prev) => !prev)}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
          <p className="auth-helper-text">{PASSWORD_RULE}</p>

          <button type="submit" disabled={loading} className="auth-btn">
            <FaUserPlus />
            {loading ? " Registering..." : " Register"}
          </button>
        </form>

        <div className="auth-footer">
          <p>Already have an account?</p>
          <button onClick={() => navigate("/login")} className="auth-link-btn">
            <FaArrowLeft /> Go to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default Register;
